import service from '@/store/services/device-models-service';

const state = {
    list: {},
    deviceModel: {},
    meta: {},
    alert: {
        id: null,
        message: '',
        type: "warning"
    },
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, deviceModel) => {
        state.deviceModel = deviceModel;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_ALERT: (state, alert) => (state.alert = alert),
};

const actions = {
    list({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({ commit, dispatch }, params) {
        return service.get(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((deviceModel) => { commit('SET_RESOURCE', deviceModel); });
    },

    update({ commit, dispatch }, params) {
        return service.update(params)
            .then((deviceModel) => { commit('SET_RESOURCE', deviceModel); });
    },

    destroy({ commit, dispatch }, params) {
        return service.destroy(params);
    },

    checkByUniqueNumber({ commit, dispatch }, params) {
        return service.checkByUniqueNumber(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    setAlert({ commit, dispatch }, alert) {
        setTimeout(()=>{
            alert.message = '';
            alert.id = null;
        }, 8000)
        commit('SET_ALERT', alert);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    deviceModel: state => state.deviceModel,
    dropdown: (state) => {
        return state.list.map(deviceModel => ({
            id: deviceModel.id,
            name: ((deviceModel.name + ' (ID: ' + deviceModel.id + ', index: ' + deviceModel.index + ')'))
        }));
    },
    alert: state => state.alert,
};

const deviceModels = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default deviceModels;